import { User } from '../types/auth';
import { API_URL, getAuthOptions } from './config';

export interface AutoApprovalDomain {
    id: number;
    domain: string;
    created_at: string;
}

export async function getUsers(): Promise<User[]> {
    const response = await fetch(`${API_URL}/admin/users`, {
        ...getAuthOptions(),
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to fetch users');
    }

    return response.json();
}

export async function updateUserRole(userId: string, role: 'ADMIN' | 'USER') {
    const response = await fetch(`${API_URL}/admin/users/${userId}/role`, {
        ...getAuthOptions(),
        method: 'PUT',
        body: JSON.stringify({ role }),
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to update user role');
    }

    return response.json();
}

export async function getAutoApprovalDomains(): Promise<AutoApprovalDomain[]> {
    const response = await fetch(`${API_URL}/admin/auto-approval-domains`, {
        ...getAuthOptions(),
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to fetch auto-approval domains');
    }

    return response.json();
}

export async function addAutoApprovalDomain(domain: string): Promise<AutoApprovalDomain> {
    const response = await fetch(`${API_URL}/admin/auto-approval-domains`, {
        ...getAuthOptions(),
        method: 'POST',
        body: JSON.stringify({ domain }),
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to add auto-approval domain');
    }

    return response.json();
}

export async function deleteAutoApprovalDomain(id: number): Promise<void> {
    const response = await fetch(`${API_URL}/admin/auto-approval-domains/${id}`, {
        ...getAuthOptions(),
        method: 'DELETE',
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to delete auto-approval domain');
    }
}

export async function deleteUser(userId: string): Promise<void> {
    const response = await fetch(`${API_URL}/admin/users/${userId}`, {
        ...getAuthOptions(),
        method: 'DELETE',
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to delete user');
    }
}

export async function approveUser(userId: string): Promise<void> {
    const response = await fetch(`${API_URL}/admin/users/${userId}/approve`, {
        ...getAuthOptions(),
        method: 'PUT',
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to approve user');
    }
}
